import {
  setInitialAnimations,
  setAnimations
} from '../animations/scroll/home'
import bidello from '../bidello'
import menu from '../menu'
import scroll from '../animations/scroll/locomotiveScroll'
import webgl from '../webgl/main'
import gsap, { Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import sound from '../sound'
import world from '../webgl/world/world'
import stars from '../webgl/stars/stars'
import { qs, addClass, removeClass, isTouch } from '../utils'
class Home {
  constructor() {
    this.namespace = 'home'
    this.isAlreadyEntered = false
    this.startExperience = this.startExperience.bind(this)
  }

  beforeEnter(to, from, next) {
    this.setInitialAnimations()
    this.setAnchors()
  }

  updateArgs(args) {
    ScrollTrigger.update(args)
  }

  refresh() {
    scroll.locoScroll.update()
  }

  setScroll() {
    scroll.locoScroll.on('scroll', this.updateArgs)

    ScrollTrigger.scrollerProxy(document.querySelector('[data-scroll-container]'), {
      scrollTop(value) {
        return arguments.length
          ? scroll.locoScroll.scrollTo(value, 0, 0)
          : scroll.locoScroll.scroll.instance.scroll.y
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight,
        }
      }
    })

    ScrollTrigger.addEventListener('refresh', this.refresh)
    ScrollTrigger.refresh()

    this.animations = [...this.animations, ...setAnimations()]
  }

  setAnchors() {
    this.anchorEvents = Array.from(document.querySelectorAll('[data-anchor]')).map((el) => {
      const onClick = e => {
        e.preventDefault()
        scroll.locoScroll.scrollTo(el.dataset.target, {
          offset: window.innerHeight * Number(el.dataset.offset)
        })
      }

      el.addEventListener('click', onClick)
      return onClick
    })
  }

  setInitialAnimations() {
    this.animations = setInitialAnimations()
  }

  afterEnter({ next }) {
    sound.init()

    const that = this
    this.animating = false
    this.ctaStart = qs('[data-cta-start]', next.container)
    this.ctaExplore = qs('[data-cta-explore]', next.container)

    this.ctaStart.addEventListener('click', this.startExperience)
    this.ctaExplore.addEventListener('click', () => that.isAlreadyEntered = true)
  }

  startExperience() {
    if (this.animating) return
    this.isAlreadyEntered = true
  
    this.animating = true
    this.animations[1].play()

    sound.unmute()
    sound.play('soundtrack')
  }

  skipStartup() {
    this.isAlreadyEntered = true
    this.animations[0].progress(1)
    this.animations[1].progress(1)
  }

  beforeLeave(data) {
    this.ctaStart.removeEventListener('click', this.bindedStart)
    bidello.trigger({ name: 'leaveHome' })
    stars.fastLeave()
  }

  destroyTriggers() {
    const allTriggers = ScrollTrigger.getAll()

    allTriggers.forEach(trigger => {
      trigger.kill(true)
    })

    this.anchorEvents.forEach((evt, i) => {
      Array.from(document.querySelectorAll('[data-anchor]'))[i].removeEventListener('click', evt)
    })

    ScrollTrigger.removeEventListener('refresh', this.refresh)
    scroll.locoScroll.off('scroll', this.updateArgs)

    scroll.locoScroll.start()
  }

  afterLeave() {
    world.reset()
  }
}

export default new Home()
